<template>
  <Layout :tituloPagina="'Inicio VPN'">
    <div class="row" v-show="!$store.state.todo.susargus">
      <div class="col-lg-12">
        <div class="card bg-warning text-white">
          <div class="card-body text-center">
            <p class="card-text">
              Su suscripción ha caducado, debe de pagar su mensualidad para seguir disfrutando de ArgusBlack, 
              visite la sección <a href="/sistema/cuenta/" style="color: red;">CUENTA</a> para renovarla en este momento.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpCredenciales','componente') && widgets.WCredenciales">
        <WCredenciales/>
      </div>
    </div>

    <widgets-visibles 
      ref="widgetsVpn"
      @actualizar-widgets="cargarAjustesWidgets()"
    ></widgets-visibles>
    <br>
  </Layout>
</template>

<script>
import UsuarioSrv from '@/services/UsuarioSrv.js'
import Layout from "@/views/layouts/main.vue"
import WCredenciales from './WCredenciales.vue'
import WidgetsVisibles from './WidgetsVisibles.vue'

import { todoGetters } from "@/state/helpers"

export default {
  name: 'Inicio',
  components: {
    Layout,
    WCredenciales,
    WidgetsVisibles
  },
  data() {
    return {
      widgets: {
        WCredenciales: false
      }
    }
  },
  created: function() {
    var self = this

    self.cargarAjustesWidgets()
  },
  computed: { ...todoGetters },
  methods: {    
    cargarAjustesWidgets: function() {
      var self = this
      var widgets = ['WCredenciales']

      UsuarioSrv.ajustesJSON(widgets).then(response => {
        let ajustes = response.data

        // Convertimos y asignamos cada valor al objeto widgets
        for (const key in ajustes) {
          if (self.widgets.hasOwnProperty(key)) {
            self.widgets[key] = ajustes[key] === '1'; // Convertimos a booleano
          }
        }
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los ajustes del widgets'
        }
        console.log(error)
        iu.msg.error(mensaje)
      })
    }
  }
}
</script>

<style scoped>

</style>